/**
 * Formats a card number string into groups of four digits.
 * @param {string} cardNumber - The card number to format. Can contain non-digit characters.
 * @returns {string} The formatted card number with spaces every four digits.
 * @example
 * formatCardNumber('4111110083093083') // Returns '4111 1100 8309 3083'
 */
export function formatCardNumber(cardNumber: string) {
  // Remove any non-digit characters from the input
  const digitsOnly = cardNumber.replace(/\D/g, '')

  return digitsOnly.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
}
